import Button from './Button';
import ButtonLink from './ButtonLink';
import Group from './ButtonGroup';
import {
  defaultStyles,
} from './styles';

Button.Group = Group;

export default Button;

export {
  ButtonLink,
  Group,
  defaultStyles,
};
